import {DOCUMENT} from '@angular/common';
import {Component, Inject, OnDestroy, OnInit, Renderer2} from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-flash-view',
  templateUrl: './flash-view.component.html',
  styleUrls: ['./flash-view.component.css']
})
export class FlashViewComponent implements OnInit {
  respObject: any;
  fileData: any;
  compObj: any;
  compData: any;
  editObject: any;

  dataType = '';
  fileYear = '';
  fullYear: number = new Date().getFullYear();
  yearArr = [];
  yearfArr = [];
  filefYear = '';
  selectMonth = '';
  fileQuarter = '';
  companyId = '';
  userId = '';
  company = '';
  companyName = '';
  downLoadPath = this._rest.FILE_PATH;

  perPageRow = this._rest.PER_PAGE_ROW + 50;
  curPage = 1;
  totalRows = 0;
  pages = [];
  noOfRows = 0;
  months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  constructor(@Inject(DOCUMENT) private document: Document,
              private renderer: Renderer2, private router: Router, private _rest: RestapiService) {
  }

  ngOnInit(): void {
    this.selectMonth = '';

    this.curPage = 1;
    for (let i = this.fullYear - 10; i <= this.fullYear; i++) {
      this.yearArr.push(i);
    }
    for (let i = this.fullYear - 10; i <= this.fullYear; i++) {
      this.yearfArr.push(i + '-' + (i + 1));
    }
    const cRData = {};
    this.companyId = localStorage.getItem('companyId');
    this.userId = localStorage.getItem('userId');

    this._rest.companyList(cRData).subscribe((res) => {
      this.compObj = res;
      this.compData = this.compObj.details;

      for (let i = 0; i < this.compData.length; i++) {
        if (this.compData[i].companyId == this.companyId) {
          this.companyName = this.compData[i].companyName;
          break;
        }
      }

    });
    this.searchFile(1);
    /*const data = {}
    this._rest.getAdminFiles(data).subscribe((res) => {
      this.respObject = res;
      if(this.respObject.error==0){
        this.fileData=this.respObject.resp;
      }
      console.log(JSON.stringify(this.respObject));
    })*/
  }

  searchFile(curPage) {
    if (this.filefYear != '' && this.selectMonth == '') {
      alert('Please select the month');
    } else {
      this.curPage = curPage;
      var fd = {};

      fd['limit'] = this.perPageRow;
      fd['page'] = this.curPage;
      fd['year'] = this.findYear();
      fd['month'] = this.selectMonth;
      if (this.companyId != '') {
        fd['companyId'] = this.companyId;
      }
      this._rest.flashView(fd).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.error == 0) {
          this.fileData = this.respObject.resp.data;
          const today = new Date();
          for (const obj of this.fileData) {
            obj.isEdit = false;
            obj.isEditDisable = true;
            if (obj.year == this.fullYear && obj.month === this.months[today.getMonth()-1]) {
              obj.isEditDisable = today.getDate() > 7;
            }
          }
          this.totalRows = this.respObject.resp.info;
          this.noOfRows = this.fileData.length;
          this.pages = [];
          for (let i = 1; i <= Math.ceil(this.totalRows / this.perPageRow); i++) {
            this.pages.push(i);
          }
        } else {
          this.fileData = [];
          this.totalRows = 0;
          this.noOfRows = 0;
          this.pages = [];
        }
      });
    }
  }

  givePermission(flag: string, fdata: any) {
    const data = {
      id: fdata.id,
      status: flag
    };
    this._rest.approveRejectFlashUploadEditReq(data).subscribe((res: any) => {
      if (res.error === 0) {
        fdata.editReq = '0';
        if (flag === '0') {
          alert('Request rejected');
        } else {
          alert('Request approved');
        }
      } else {
        alert(res.errorMessage);
      }
    });
  }

  reqEditFlashUpload(fdata: any) {
    if(confirm("Are you sure you want to request for an edit?")){
      const data = {
        id: fdata.id
      };
      const data1 = {
        "fileId":fdata.id,
        "action":"edit",
        "user": this.userId,
        "templateType": 'Flash',
      };
      this._rest.fileDeleteRequest(data1).subscribe((res) => {
        this.editObject=res;
        if(this.editObject.error==0){
          alert(this.editObject.resp);
          //window.location.reload();
          this.ngOnInit();
        } else {
          alert(this.editObject.errorMessage);
        }
      });

      this._rest.reqEditFlashUpload(data).subscribe((res: any) => {
        if (res.error === 0) {
          fdata.editReq = '1';
          alert('Request submitted successfully.');
        } else {
          alert(res.errorMessage);
        }
      });
  }

  }

  saveEditedData(fdata: any) {
    const data = {
      companyId: fdata.companyId,
      createdBy: fdata.createdBy,
      forMonth: fdata.forMonth,
      forMonthPrev: fdata.forMonthPrev,
      id: fdata.id,
      month: fdata.month,
      uptoMonth: fdata.uptoMonth,
      uptoMonthPrev: fdata.uptoMonthPrev,
      year: fdata.year,
      ignoreData: 0
    };
    this._rest.updateFlashUpload(data).subscribe((res: any) => {
      // console.log(res)
      if (res.error === 0) {
        fdata.isEdit = false;
        fdata.isEditPermision = '0';
        alert('Flash data has been updated successfully.');
      } else {
        // console.log(res)
        // console.log(res.errorMessage)
        if (res.errorMessage === 'Some error occurred' || res.errorMessage === 'Required data missing'){

          alert(res.errorMessage);
          console.log(res.errorMessage)
        }else{

        
          if(confirm(res.errorMessage + '\nDo you want to upload ignoring the message?')){
          const data = {
            companyId: fdata.companyId,
            createdBy: fdata.createdBy,
            forMonth: fdata.forMonth,
            forMonthPrev: fdata.forMonthPrev,
            id: fdata.id,
            month: fdata.month,
            uptoMonth: fdata.uptoMonth,
            uptoMonthPrev: fdata.uptoMonthPrev,
            year: fdata.year,
            ignoreData: 1
          };
          this._rest.updateFlashUpload(data).subscribe((res: any) => {
            if (res.error === 0) {
              fdata.isEdit = false;
              fdata.isEditPermision = '0';
              alert('Flash data has been updated successfully.');
            } 
          });

          }
        }
      }
    });
  }

  chngCompId() {
    this.companyId = this.company;
  }

  findYear() {
    if (this.filefYear != '' && this.selectMonth != '') {
      var yrArr = this.filefYear.split('-');
      if (this.selectMonth == 'January' || this.selectMonth == 'February' || this.selectMonth == 'March') {
        this.fileYear = yrArr[1];
      } else {
        this.fileYear = yrArr[0];
      }
    } else {
      this.fileYear = '';
    }
    return this.fileYear;
  }
}

